import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import '../../css/addproperty.css';
import '../../css/addroomdetails.css';
import '../../css/styles.css';
import chennaipincode from '../../assets/pincode.json';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";
import Dashboard from './Dashboard';


const customIcon = new L.Icon({
  iconUrl: markerIconPng,
  shadowUrl: markerShadowPng,
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});


const LocationSelector = ({ setPosition, setAddress }) => {
  useMapEvents({
    click: async (e) => {
      const { lat, lng } = e.latlng;
      setPosition([lat, lng]);

      // Fetch address using reverse geocoding
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
        );
        const data = await response.json();
        if (data.display_name) {
          setAddress(data.display_name);
        } else {
          setAddress("Address not found");
        }
      } catch (error) {
        console.error("Error fetching address:", error);
      }
    }
  });

  return null;
};

const steps = [
  { id: 1, label: "Property Details" },
  { id: 2, label: "Address" },
  { id: 3, label: "Photos" },
  { id: 4, label: "Verify" },
  { id: 5, label: "Review" },
];

const AddProperty = ({ agent_id, agent_name}) => {

  const pincodeData = chennaipincode;
  const [currentStep, setCurrentStep] = useState(1);
  const [step, setStep] = useState(1);
  const [propertyType, setPropertyType] = useState("");
  const [lookingTo, setLookingTo] = useState("");
  const [building, setBuilding] = useState("");
  const [locality, setLocality] = useState("");
  const [pgName, setPgName] = useState("");
  const [totalBeds, setTotalBeds] = useState("");
  const [pgFor, setPgFor] = useState("");
  const [bestSuitedFor, setBestSuitedFor] = useState("");
  const [mealsAvailable, setMealsAvailable] = useState("");
  const [mealOfferings, setMealOfferings] = useState([]);
  const [mealSpeciality, setMealSpeciality] = useState([]);
  const [noticePeriod, setNoticePeriod] = useState("");
  const [lockInPeriod, setLockInPeriod] = useState("");
  const [commonArea, setCommonArea] = useState([]);
  const [propertyManaged, setPropertyManaged] = useState([]);
  const [managerStaysAt, setManagerStaysAt] = useState("");
  const [nonVegAllowed, setNonVegAllowed] = useState("");
  const [oppositeSexAllowed, setOppositeSexAllowed] = useState("");
  const [anyTimeAllowed, setAnyTimeAllowed] = useState("");
  const [visitorsAllowed, setVisitorsAllowed] = useState("");
  const [guardianAllowed, setGuardianAllowed] = useState("");
  const [drinkingAllowed, setDrinkingAllowed] = useState("");
  const [smokingAllowed, setSmokingAllowed] = useState("");
  const [lastTimeEntry, setLastTimeEntry] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedPincode, setSelectedPincode] = useState('');
  const [localities, setLocalities] = useState([]);
  const [selectedLocality, setSelectedLocality] = useState('');
  const [Address, setAddress] = useState("");
  const [position, setPosition] = useState([113.0827, 80.2707]); // Default Lat/Lng for Velachery
  const [paraaddress, setParaAddress] = useState("");
  const [roomType, setRoomType] = useState("");
  const [totalBeds1, setTotalBeds1] = useState('');
  const [rent, setRent] = useState('');
  const [securityDeposit, setSecurityDeposit] = useState('');
  const [facilities, setFacilities] = useState([]);
  const [topamenities, setTopamenities] = useState([]);
  const [service, setService] = useState([]);
  const [furnishingsinprop, setFurnishingsinprop] = useState([]);
  const [securityamenities, setSecurityamenities] = useState([]);
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const wrapperRef = useRef(null);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({propertyType:'', lookingTo:''});

   // Define refs for each field
   const refs = {
    propertyType: useRef(null),
    lookingTo: useRef(null),
    locality: useRef(null),
    building: useRef(null),
    selectedPincode: useRef(null),
    selectedLocality: useRef(null),
    pgName: useRef(null),
    totalBeds: useRef(null),
    pgFor: useRef(null),
    bestSuitedFor: useRef(null),
    mealsAvailable: useRef(null),
    mealOfferings: useRef(null),
    noticePeriod: useRef(null),
    lockInPeriod: useRef(null),
    commonArea: useRef(null),
    propertyManaged: useRef(null),
    managerStaysAt: useRef(null),
    nonVegAllowed: useRef(null),
    oppositeSexAllowed: useRef(null),
    anyTimeAllowed: useRef(null),
    visitorsAllowed: useRef(null),
    guardianAllowed: useRef(null),
    drinkingAllowed: useRef(null),
    smokingAllowed: useRef(null),
    lastTimeEntry: useRef(null),
    roomType: useRef(null),
    rent: useRef(null),
    securityDeposit: useRef(null),
    images: useRef(null),
    securityamenities: useRef(null),
    furnishingsinprop: useRef(null),
    service: useRef(null),
    topamenities: useRef(null),
    Address: useRef(null),
    facilities: useRef(null),
    // totalBeds1: useRef(null),
  };

  const getRefByKey = (key) => refs[key];
  
    const validateForm = () => {
      let newErrors = {};
      let firstErrorRef = null;
    
      // Step 1: Property Details Validation
      if (currentStep === 1) {
        if (!propertyType) newErrors.propertyType = "Property Type is required.";
        if (!lookingTo) newErrors.lookingTo = "Looking To is required.";
        if (!locality) newErrors.locality = "Locality is required.";
        if (!building) newErrors.building = "Building Name is required.";
        if (!selectedPincode) newErrors.pincode = "Pincode is required.";
        if (!selectedLocality) newErrors.selectedLocality = "Locality selection is required.";
        if (!pgName) newErrors.pgName = "PG Name is required.";
        if (!totalBeds) newErrors.totalBeds = "Total Beds are required.";
        if (!pgFor) newErrors.pgFor = "PG for is required.";
        if (!bestSuitedFor) newErrors.bestSuitedFor = "Best suited option is required.";
        if (!mealsAvailable) newErrors.mealsAvailable = "Meals Availability is required.";
        if (mealsAvailable === "Yes" && mealOfferings.length === 0) {
          newErrors.mealOfferings = "Select at least one meal offering.";
        }
        if (!noticePeriod) newErrors.noticePeriod = "Notice period is required.";
        if (!lockInPeriod) newErrors.lockInPeriod = "Lock-in period is required.";
        if (commonArea.length === 0) newErrors.commonArea = "Select at least one common area.";
        if (propertyManaged.length === 0) newErrors.propertyManaged = "Property Managed By is required.";
        if (!managerStaysAt) newErrors.managerStaysAt = "Manager Stays At Property is required.";
        if (!nonVegAllowed) newErrors.nonVegAllowed = "Non Veg Allowed is required.";
        if (!oppositeSexAllowed) newErrors.oppositeSexAllowed = "Opposite Sex Allowed is required.";
        if (!anyTimeAllowed) newErrors.anyTimeAllowed = "Any Time Allowed is required.";
        if (!visitorsAllowed) newErrors.visitorsAllowed = "Visitors Allowed is required.";
        if (!guardianAllowed) newErrors.guardianAllowed = "Guardian Allowed is required.";
        if (!drinkingAllowed) newErrors.drinkingAllowed = "Drinking Allowed is required.";
        if (!smokingAllowed) newErrors.smokingAllowed = "Smoking Allowed is required.";
        if (!lastTimeEntry) newErrors.lastTimeEntry = "Last Time Entry is required.";
      }
    
      // Step 2: Room Details Validation
      if (currentStep === 2) {
        if (!roomType) newErrors.roomType = "Room Type is required.";
        // if (!totalBeds1) newErrors.totalBeds1 = "Total Beds is required.";
        if (!rent) newErrors.rent = "Rent is required.";
        if (!securityDeposit) newErrors.securityDeposit = "Security Deposit  required.";
        if (!facilities.length) newErrors.facilities = "Select at least one facility.";
      }
    
      // Step 3: Amenities Validation
      if (currentStep === 3) {
        if (securityamenities.length === 0) newErrors.securityamenities = "Select at least one security amenity.";
        if (furnishingsinprop.length === 0) newErrors.furnishingsinprop = "Select at least one furnishing.";
        if (service.length === 0) newErrors.service = "Select at least one service.";
        if (topamenities.length === 0) newErrors.topamenities = "Select at least one top amenity.";
      }
    
      // Step 4: Address Validation
      if (currentStep === 4) {
        if (!selectedLocality.trim()) newErrors.selectedLocality = "Locality is required.";
        if (!Address.trim()) newErrors.Address = "Address is required.";
      }
    
      setErrors(newErrors);
    
      if (firstErrorRef) {
        firstErrorRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    
      return Object.keys(newErrors).length === 0;
    };
  
    const handleNextStep = () => {
      if (validateForm()) {
        setCurrentStep((prev) => prev + 1);
        navigateToNextPage();
      }
    };
  
  const handlePrevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const navigateToNextPage = () => {
    if (propertyType === "Residential" && lookingTo === "Rent") {
      navigate("/residential-rent");
    } else if (propertyType === "Residential" && lookingTo === "Resale") {
      navigate("/residential-resell");
    }
  };


  const handleLookingToClick = (option) => {
    setLookingTo(option);

    // Redirect based on selection
    if (propertyType === "Residential" && option === "Rent") {
      navigate("/residential-rent");
    } else if (propertyType === "Residential" && option === "Resale") {
      navigate("/residential-resell");
    } else if (propertyType === "Residential" && option === "PG/Co-living") {
      navigate("/pg-co-living");
    } else if (propertyType === "Commercial" && option === "Rent") {
      navigate("/Commercial-rent");
    } else if (propertyType === "Commercial" && option === "Resale") {
      navigate("/Commercial-resale");
    }
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchCoordinates = async () => {
      if (!selectedLocality.trim()) return;
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${selectedLocality}, Chennai`
        );
        const data = await response.json();
        if (data.length > 0) {
          const lat = parseFloat(data[0].lat);
          const lon = parseFloat(data[0].lon);
          setPosition([lat, lon]);
          setAddress(data[0].display_name);
        } else {
          setAddress("Location not found");
        }
      } catch (error) {
        console.error("Error fetching coordinates:", error);
      }
    };

    if (selectedLocality) {
      fetchCoordinates();
    }
  }, [selectedLocality]);

  // Filter pincode suggestions based on the search term
  const filteredPincodes = pincodeData.filter(item =>
    item.pincode.includes(searchTerm)
  );

  // Handle changes in the pincode input field
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setShowSuggestions(true);
    if (!value) {
      setShowSuggestions(false);
    }
    if (value.length === 6) {
      setErrors({ ...errors, pincode: "" });
    }
  };

  // Handle selecting a pincode from suggestions
  const handleSelect = (pincode) => {
    setSelectedPincode(pincode);
    const selected = pincodeData.find(item => item.pincode === pincode);
    setLocalities(selected ? selected.locality : []);
    setShowSuggestions(false);
    setErrors({ ...errors, pincode: "" });
  };

  // Handle selecting a locality
  const handleLocalityChange = (event) => {
    setSelectedLocality(event.target.value);
    setErrors({ ...errors, selectedLocality: "" });
  };



  const pmTimes = [
    "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM", "2:30 PM", "3:00 PM", "3:30 PM",
    "4:00 PM", "4:30 PM", "5:00 PM", "5:30 PM", "6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM",
    "8:00 PM", "8:30 PM", "9:00 PM", "9:30 PM", "10:00 PM", "10:30 PM", "11:00 PM", "11:30 PM"
  ];

  const facilityOptions = [
    "AC",
    "TV in Room",
    "Personal Cupboard",
    "Table Chair",
    "Attached Balcony",
    "Attached Bathroom",
    "Meals Included"
  ];

  const handleFacilityToggle = (facility) => {
    setFacilities((prev) =>
      prev.includes(facility)
        ? prev.filter((item) => item !== facility)
        : [...prev, facility]
    );
  };

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    setImages([...images, ...files]);
  };

  const handleVideoUpload = (event) => {
    const files = Array.from(event.target.files);
    setVideos([...videos, ...files]);
  };

  const [selectedAmenities, setSelectedAmenities] = useState([]);

  const secuamenities = ["CCTV", "Gated Community", "Security", "Biometric"];

  const FurnishingsinProperty = [
    "Fridge",
    "Washing Machine",
    "Microwave",
    "Water Purifier",
    "TT Table",
    "TV",
    "Coffee Machine",
    "Snacks Machine",
  ];

  const service1 = ["Laundry", "Housekeeping", "Internet/Wi-Fi Connectivity"];

  const topamenities1 = [
    "Gym",
    "Lift",
    "Regular Water Supply",
    "Swimming Pool",
    "Reserved Parking",
    "Power Backup",
  ];

  const handleAmenityToggle = (amenity) => {
    setSelectedAmenities((prev) =>
      prev.includes(amenity)
        ? prev.filter((item) => item !== amenity)
        : [...prev, amenity]
    );
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("proptype", propertyType);
    formData.append("lookingto", lookingTo);
    formData.append("bpn", building);
    formData.append("city", "Chennai");
    formData.append("pincode", selectedPincode);
    formData.append("pinlocality", selectedLocality);
    formData.append("pgname", pgName);
    formData.append("totalbeds", totalBeds);
    formData.append("pgfor", pgFor); // Add age of property if applicable
    formData.append("bestsuitedfor", bestSuitedFor);
    formData.append("mealsavailable", mealsAvailable);
    formData.append("mealofferings", mealOfferings);
    formData.append("mealspeciality", mealSpeciality); // Add preferred tenant type if applicable
    formData.append("noticeperiod", noticePeriod);
    formData.append("lockinperiod", lockInPeriod); // Add available from date if applicable
    formData.append("commonarea", commonArea);
    formData.append("propertymanaged", propertyManaged);
    formData.append("managerstaysat", managerStaysAt);
    formData.append("nonvegallowed", nonVegAllowed);
    formData.append("oppositesexallowed", oppositeSexAllowed);
    formData.append("anytimeallowed", anyTimeAllowed);
    formData.append("visitorsallowed", visitorsAllowed);
    formData.append("guardianallowed", guardianAllowed);
    formData.append("drinkingallowed", drinkingAllowed);
    formData.append("smokingallowed", smokingAllowed);
    formData.append("lasttimeentry", lastTimeEntry);
    formData.append("roomtype", roomType);
    formData.append("totalbeds1", totalBeds1);
    formData.append("rent", rent);
    formData.append("securitydeposit", securityDeposit);
    formData.append("facilities", facilities.join(", "));
    formData.append("topamenities", topamenities.join(", "));
    formData.append("service", service.join(", "));
    formData.append("furnishingsinprop", furnishingsinprop.join(", "));
    formData.append("securityamenities", securityamenities.join(", "));
    formData.append("agent_name", agent_name);
    formData.append("agent_id", agent_id);
    formData.append("address", Address);

    formData.append("fdt", new Date().toISOString());
    formData.append("status", "active");

    images.forEach((image, index) => {
      formData.append(`images`, image);
    });

    videos.forEach((video, index) => {
      formData.append(`video`, video);
    });

    try {
      const response = await axios.post("/add-property", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(response.data);
      alert("Property added successfully");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form", error.message);
    }
  };


  return (
    <div><Dashboard />
    <div className="postprop" >

         {/* Sidebar */}
         <div className="sidebar">
        <h2>Post your property</h2>
        <p>Welcome! &nbsp;{agent_name} || {agent_id} </p>
        <p>ReSell or rent your property</p>

        <div className="timeline">
          {steps.map((step) => (
            <div key={step.id} className={`step ${step.id < currentStep ? "complete" : step.id === currentStep ? "active" : ""}`}>
              <div className="circle">{step.id < currentStep ? "✓" : step.id}</div>
              <div className="label">
                <p>{step.label}</p>
                <span>{step.id < currentStep ? "Completed" : step.id === currentStep ? "In progress" : "Pending"}</span>
              </div>
            </div>
          ))}
        
        </div>
        <span>need help: call +91 9585973683</span>
      </div>

      {/* Add PG/Co-living Properties */}
      <div className="form-section">
      <div className="form-container ">
      

      {currentStep === 1 && (
          <div>
            <h2 className="text-xl font-semibold mb-4">Add Property Details</h2>

            {/* Property Type */}
            <div className="mb-4">
              <p className="mb-2 font-medium">Property Type *</p>
              <div className=" button-group">
                <button
                  className={`button ${propertyType === "Residential" ? "selected" : ""}`}
                  onClick={() => setPropertyType("Residential")}
                >
                  Residential
                </button>
                <button
                  className={`button ${propertyType === "Commercial" ? "selected" : ""}`}
                  onClick={() => setPropertyType("Commercial")}
                >
                  Commercial
                </button>

              </div>
             
            </div>

            {/* Looking To */}
            <div className="mb-4">
              <p className="mb-2 font-medium">Looking to *</p>
              <div className=" button-group">
                {(propertyType === "Residential"
                  ? ["Rent", "Resale", "PG/Co-living"]
                  : ["Rent", "Resale"]
                ).map((option) => (
                  <button
                    key={option}
                    className={`btnsmall ${lookingTo === option ? "btnsmall-selected" : ""
                      }`}
                    onClick={() => handleLookingToClick(option)}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>


            {/* Locality */}
            <div className="mb-4">
              <label className="block mb-2 font-medium">Entre City *</label>
              <input
                type="text"
                value={locality}
                onChange={(e) => {
                  setLocality(e.target.value);
                setErrors({ ...errors, locality: "" });
              }}
                className="w-full border p-2 rounded-lg"
                placeholder="Enter City"
                required 
              />
              {errors.locality && (
        <span style={{ color: 'red',fontSize: '0.8rem' }}
        className="text-sm">{errors.locality}
        </span>)}
            </div>
            


            {/* Building Details */}
            <div className="mb-4">
            <label className="block mb-2 font-medium"> Building details *</label>
              <input
                type="text"
                value={building}
                onChange={(e) => {
                  setBuilding(e.target.value);
                setErrors({ ...errors, building: "" });
               }}
                className="w-full border p-2 rounded-lg"
                placeholder="Building/Project/Society"
                required
              />
               {errors.building && (
        <span style={{ color: 'red',fontSize: '0.8rem' }}
        className="text-sm">{errors.building}
        </span>)}
            </div>


            {/* Enter Pincode */}
            <div className="mb-4" >
                <label className='block mb-2 font-medium' htmlFor="pincode">Enter Pincode *</label>
                <input
                  type="number"
                  id="pincode"
                  className="w-full border p-2 rounded-lg"
                  value={selectedPincode || searchTerm}
                  onChange={handleInputChange}
                  placeholder="Type pincode"
                  autoComplete="off"
                  required
                  inputMode="numeric"
                  maxLength={6} // Stops extra input
                />
                  {errors.pincode && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} 
                  className="text-sm">{errors.pincode}
                  </span>
                )}
              </div>

              {/* Suggestions dropdown for pincode */}
              {showSuggestions && (
                <div className="suggestions-dropdown shadow-sm mb-4">
                  {filteredPincodes.length > 0 ? (
                    filteredPincodes.map((item) => (
                      <div
                        key={item.pincode}
                        className="suggestion-item"
                        onClick={() => {
                          handleSelect(item.pincode);
                          setErrors({ ...errors, pincode: "" });
                        }}
                      >
                        <div className="pincode">{item.pincode}</div>
                        <div className="area">{item.area}</div>
                      </div>
                    ))
                  ) : (
                    <div className="no-results">No pincodes found</div>
                  )}
                </div>
              )}

              {/* After selecting pincode, show locality dropdown */}
              {selectedPincode && (
                <>
                  <div className="mb-4">
                    <label 
                    className='block mb-2 font-medium' 
                    htmlFor="locality"
                    >
                      Select Locality:
                      </label>
                    <select
                      id="locality"
                      value={selectedLocality}
                      onChange={handleLocalityChange}
                      className="w-full border p-2 rounded-lg"
                    >
                      <option value="">Select a locality</option>
                      {localities.map((locality, index) => (
                        <option key={index} value={locality}>
                          {locality}
                        </option>
                      ))}
                      </select>
                      </div>
                    {errors.selectedLocality && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} 
                  className="text-sm">{errors.selectedLocality}
                  </span>
                )}
                </>
              )}

            {/* PG Details */}
            <h2>PG Details</h2>
            <div className="mb-4">
              <label className="block mb-2 font-medium">PG Name</label>
              <input
                type="text"
                value={pgName}
                onChange={(e) => {
                  setPgName(e.target.value);
                setErrors({ ...errors, pgName: "" });
              }}
                className="w-full border p-2 rounded-lg"
                placeholder="Enter PG Name"
                required
              />
              {errors.pgName && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} 
                  className="text-sm">{errors.pgName}
                  </span>
                )}
            </div>

            {/* Total Beds */}
            <div className="mb-4">
              <label className="block mb-2 font-medium">Total Beds *</label>
              <input
                type="number"
                value={totalBeds}
                onChange={(e) => {
                  setTotalBeds(e.target.value);
                setErrors({ ...errors, totalBeds: "" });
              }}
                className="w-full border p-2 rounded-lg"
                placeholder="Enter total beds"
                required
              />
               {errors.totalBeds && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} 
                  className="text-sm">{errors.totalBeds}
                  </span>
                )}
            </div>

            {/* Additional PG Details */}
            <div className="mb-4">
              <label className="block mb-2 font-medium">PG is for *</label>
              <div className=" button-group">
                {["Girls", "Boys"].map((option) => (
                  <button key={option} 
                  className={`grid-item ${pgFor === option ? "active" : " "}`} 
                  onClick={() => {setPgFor(option);
                  setErrors({ ...errors, pgFor: "" });
                  }}
                  required
                  >
                    {option}
                  </button>
                ))}
                {errors.pgFor && (
              <span style={{ color: 'red',fontSize: '0.8rem' }} 
                className="text-sm">{errors.pgFor}
              </span>
              )}
              </div>
            </div>
            {/* Best Suited For */}
            <div className="mb-4">
              <label className="block mb-2 font-medium">Best suited for *</label>
              <div className=" button-group">
                {["Students", "Professionals"].map((option) => (
                  <button key={option} 
                  className={`grid-item ${bestSuitedFor === option ? "active" : " "}`} 
                  onClick={() => {
                    setBestSuitedFor(option);
                    setErrors({ ...errors, bestSuitedFor: "" });
                  }}
                  required
                    >
                    {option}
                  </button>
                ))}
              </div>
              {errors.bestSuitedFor && (
              <span style={{ color: 'red',fontSize: '0.8rem' }} 
                className="text-sm">{errors.bestSuitedFor}
              </span>
              )}
            </div>

            {/* Meals Available */}
            <div className="mb-4">
              <label className="block mb-2 font-medium">Meals Available *</label>
              <div className=" button-group">
                {["Yes", "No"].map((option) => (
                  <button key={option} 
                  className={`grid-item ${mealsAvailable === option ? "active" : " "}`} 
                  onClick={() => {
                    setMealsAvailable(option);
                    setErrors({ ...errors, mealsAvailable: "" });
                    }}
                    required
                    >
                    {option}
                  </button>
                ))}
              </div>
              {errors.mealsAvailable && (
              <span style={{ color: 'red',fontSize: '0.8rem' }} 
                className="text-sm">{errors.mealsAvailable}
              </span>
              )}
            </div>

            {mealsAvailable === "Yes" && (
              <>
                {/* Meal Offerings */}
                <div className="mb-4">
                  <label className="block mb-2 font-medium">Meal Offerings *</label>
                  <div className=" button-group">
                    {["Breakfast", "Lunch", "Dinner"].map((option) => (
                      <button key={option} 
                      className={`grid-item ${mealOfferings.includes(option) ? "active" : " "}`} 
                      onClick={() => {
                        setMealOfferings(prev => prev.includes(option) ? prev.filter(item => item !== option) : [...prev, option]);
                       setErrors({ ...errors, mealOfferings: "" });
                      }}
                      required
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                  {errors.mealOfferings && (
              <span style={{ color: 'red',fontSize: '0.8rem' }} 
                className="text-sm">{errors.mealOfferings}
              </span>
              )}
                </div>

                {/* Meal Speciality */}
                <div className="mb-4">
                  <label className="block mb-2 font-medium">Meal Speciality (Optional)</label>
                  <div className=" button-group">
                    {["Punjabi", "South Indian", "Andhra", "North Indian", "Others"].map((option) => (
                      <button key={option} 
                      className={`grid-item ${mealSpeciality.includes(option) ? "active" : " "}`} 
                      onClick={() => {
                        setMealSpeciality(prev => prev.includes(option) ? prev.filter(item => item !== option) : [...prev, option]);
                        setErrors({ ...errors, mealSpeciality: "" });
                        }}
                        required
                        >
                        {option}
                      </button>
                    ))}
                  </div>
                  {errors.mealOfferings && (
              <span style={{ color: 'red',fontSize: '0.8rem' }} 
                className="text-sm">{errors.mealOfferings}
              </span>
              )}
                </div>
              </>
            )}

            {/* Notice Period */}
            <div className="mb-4">
              <label className="block mb-2 font-medium">Notice Period (Days) *</label>
              <input
                type="number"
                value={noticePeriod}
                onChange={(e) => {setNoticePeriod(e.target.value);
                setErrors({ ...errors, noticePeriod: "" });
                }}
                className="w-full border p-2 rounded-lg"
                placeholder="Enter notice period in days"
              />
               {errors.noticePeriod && (
              <span style={{ color: 'red',fontSize: '0.8rem' }} 
                className="text-sm">{errors.noticePeriod}
              </span>
              )}
            </div>

            {/* Lock-in Period */}
            <div className="mb-4">
              <label className="block mb-2 font-medium">Lock-in Period (Days) *</label>
              <input
                type="number"
                value={lockInPeriod}
                onChange={(e) => {setLockInPeriod(e.target.value);
                setErrors({ ...errors, lockInPeriod: "" });
                }}
                className="w-full border p-2 rounded-lg"
                placeholder="Enter lock-in period in days"
                required
              />
                {errors.lockInPeriod && (
              <span style={{ color: 'red',fontSize: '0.8rem' }} 
                className="text-sm">{errors.lockInPeriod}
              </span>
              )}
            </div>
            {/* Common Areas */}
            <div className="mb-4">
              <label className="block mb-2 font-medium">Common Areas (*)</label>
              <div className=" button-group">
                {["Living Room", "Kitchen", "Dining Hall", "Study Room / Library", "Breakout Rom"].map((option) => (
                  <button key={option} 
                  className={`grid-item ${commonArea.includes(option) ? "active" : " "}`} 
                  onClick={() => {
                    setCommonArea(prev => prev.includes(option) ? prev.filter(item => item !== option) : [...prev, option]);
                    setErrors({ ...errors, commonArea: "" });
                    }}
                    required
                    >
                    {option}
                  </button>
                ))}
              </div>
              {errors.commonArea && (
              <span style={{ color: 'red',fontSize: '0.8rem' }} 
                className="text-sm">{errors.commonArea}
              </span>
              )}
            </div>
            <hr />


            {/* Property Managed By section */}

            <h2>Owner/Caretaker Details</h2>
            <div className="mb-4">
  <label className="block mb-2 font-medium">Property Managed By (*)</label>
  <div className="button-group">
    {["Landlord", "Caretaker", "Dedicated Professional"].map((option) => (
      <button
        key={option}
        className={`grid-item ${propertyManaged === option ? "active" : ""}`}
        onClick={() => {
          setPropertyManaged(option);
          setErrors({ ...errors, propertyManaged: "" });
        }}
        required
      >
        {option}
      </button>
    ))}
  </div>
  {errors.propertyManaged && (
    <span style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">
      {errors.propertyManaged}
    </span>
  )}
</div>
            
            {/* Property Managed Stays at Property */}
            <div className="mb-4">
  <label className="block mb-2 font-medium">Property Manager Stays at Property(*)</label>
  <div className="button-group">
    {["Yes", "No"].map((option) => (
      <button
        key={option}
        className={`grid-item ${managerStaysAt === option ? "active" : ""}`}
        onClick={() => {
          setManagerStaysAt(option);
          setErrors({ ...errors, managerStaysAt: "" });
        }}
        required
      >
        {option}
      </button>
    ))}
  </div>
  {errors.managerStaysAt && (
    <span style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">
      {errors.managerStaysAt}
    </span>
  )}
</div>
            <hr />


            {/* PG RULES */}

            <h2 className="text-xl font-semibold mb-4">PG RULES</h2>
            <div className="grid grid-cols-2 gap-4">

              {/* Non Veg Allowed */}
              <div className="flex flex-col">
               <label className="mb-2 font-medium">Non Veg Allowed *</label>
               <div className="button-group">
                  {["Yes", "No"].map((option) => (
                   <button
                   key={option}
                   className={`grid-item ${nonVegAllowed === option ? "active" : ""}`}
                   onClick={() => {
                    setNonVegAllowed(option);
                    setErrors({ ...errors, nonVegAllowed: "" });
                     }}
                        required
                      >
                        {option}
                      </button>
                    ))}
            </div>
            {errors.nonVegAllowed && (
              <span style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">
                {errors.nonVegAllowed}
              </span>
            )}
          </div>

              {/* Opposite Sex Allowed */}
              <div className="flex flex-col">
                <label className="mb-2 font-medium">Opposite Sex Allowed *</label>
                <div className=" button-group">
                  {["Yes", "No"].map((option) => (
                  <button
                  key={option} 
                  className={`grid-item ${oppositeSexAllowed === option ? "active" : ""}`}
                  onClick={() => {
                    setOppositeSexAllowed(option);
                  setErrors({...errors,oppositeSexAllowed});
                }}
                required
                >
                  {option}
                </button>
                ))}
                </div>
                {errors.oppositeSexAllowed && (
                  <span 
                  style={{ color: 'red', fontSize: '0.8rem' }} 
                  className="text-sm">{errors.oppositeSexAllowed}
                  </span>
                )}
              </div>

              {/* Any Time Allowed */}
<div className="flex flex-col">
  <label className="mb-2 font-medium">Any Time Allowed *</label>
  <div className="button-group">
    {["Yes", "No"].map((option) => (
      <button
        key={option}
        className={`grid-item ${anyTimeAllowed === option ? "active" : ""}`}
        onClick={() => {
          setAnyTimeAllowed(option);
          setErrors({ ...errors, anyTimeAllowed: "" });
        }}
        required
      >
        {option}
      </button>
    ))}
  </div>
  {errors.anyTimeAllowed && (
    <span style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">
      {errors.anyTimeAllowed}
    </span>
  )}
</div>

{/* Visitors Allowed */}
<div className="flex flex-col">
  <label className="mb-2 font-medium">Visitors Allowed *</label>
  <div className="button-group">
    {["Yes", "No"].map((option) => (
      <button
        key={option}
        className={`grid-item ${visitorsAllowed === option ? "active" : ""}`}
        onClick={() => {
          setVisitorsAllowed(option);
          setErrors({ ...errors, visitorsAllowed: "" });
        }}
        required
      >
        {option}
      </button>
    ))}
  </div>
  {errors.visitorsAllowed && (
    <span style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">
      {errors.visitorsAllowed}
    </span>
  )}
</div>

{/* Guardian Allowed */}
<div className="flex flex-col">
  <label className="mb-2 font-medium">Guardian Allowed *</label>
  <div className="button-group">
    {["Yes", "No"].map((option) => (
      <button
        key={option}
        className={`grid-item ${guardianAllowed === option ? "active" : ""}`}
        onClick={() => {
          setGuardianAllowed(option);
          setErrors({ ...errors, guardianAllowed: "" });
        }}
        required
      >
        {option}
      </button>
    ))}
  </div>
  {errors.guardianAllowed && (
    <span style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">
      {errors.guardianAllowed}
    </span>
  )}
</div>

{/* Drinking Allowed */}
<div className="flex flex-col">
  <label className="mb-2 font-medium">Drinking Allowed *</label>
  <div className="button-group">
    {["Yes", "No"].map((option) => (
      <button
        key={option}
        className={`grid-item ${drinkingAllowed === option ? "active" : ""}`}
        onClick={() => {
          setDrinkingAllowed(option);
          setErrors({ ...errors, drinkingAllowed: "" });
        }}
        required
      >
        {option}
      </button>
    ))}
  </div>
  {errors.drinkingAllowed && (
    <span style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">
      {errors.drinkingAllowed}
    </span>
  )}
</div>

{/* Smoking Allowed */}
<div className="flex flex-col">
  <label className="mb-2 font-medium">Smoking Allowed *</label>
  <div className="button-group">
    {["Yes", "No"].map((option) => (
      <button
        key={option}
        className={`grid-item ${smokingAllowed === option ? "active" : ""}`}
        onClick={() => {
          setSmokingAllowed(option);
          setErrors({ ...errors, smokingAllowed: "" });
        }}
        required
      >
        {option}
      </button>
    ))}
  </div>
  {errors.smokingAllowed && (
    <span style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">
      {errors.smokingAllowed}
    </span>
  )}
</div>

              {/* Last Time Entry Dropdown */}
              <div className="flex flex-col">
                <label className="mb-2 font-medium">Last Time Entry *</label>
                <select 
                className="px-4 py-2 border rounded-lg" 
                value={lastTimeEntry} 
                onChange={(e) => {
                  setLastTimeEntry(e.target.value);
                  setErrors({ ...errors, lastTimeEntry: "" });
                  }}
                  required
                  >
                  {pmTimes.map((time) => (
                    <option key={time} value={time}>{time}</option>
                  ))}
                </select>
                {errors.lastTimeEntry && (
      <span style={{ color: 'red', fontSize: '0.8rem' }} className="text-sm">{errors.lastTimeEntry}</span>
    )}
              </div>

              {/* <button onClick={() => setStep(2)} className="next-button">
                Next, add Rooms
              </button> */}
            </div>
          </div>
        )}




        {/* ----------------------------------------------- Add Room Details ------------------------------------------------------------ */}
        {currentStep === 2 && (

          // Room Details
          <div>
            <h2 className="text-xl font-semibold mb-4">Add Room Details</h2>
            <div className="mb-4">
              <label className="block mb-2 font-medium">Room Type *</label>
              <div className=" button-group">
                {["Private Room", "Double Sharing", "Triple Sharing", "3+ Sharing"].map((type) => (
                  <button
                    key={type}
                    className={`grid-item ${roomType === type ? "active" : " "}`}
                    onClick={() => {
                      setRoomType(type);
                      setErrors({ ...errors, roomType: "" });
                    }}
                    required
                  >
                    {type}
                  </button>
                ))}
              </div>
                {errors.roomType && (
                 <span 
                 style={{ color: 'red', fontSize: '0.8rem' }} 
                 className="text-sm">{errors.roomType}
                 </span>
               )}
            </div>

            {/* Total Beds */}
            <div className="mb-4">
              <label className="block mb-2 font-medium">Total Beds in Room (Optional)</label>
              <input
                type="number"
                value={totalBeds1}
                placeholder='Enter total beds'
                onChange={(e) => {
                  setTotalBeds1(e.target.value);
                setErrors({ ...errors, totalBeds1: "" });
              }}
              required
                className="w-full p-2 border rounded-lg"
              />
               {/* {errors.totalBeds1 && (
                 <span 
                 style={{ color: 'red', fontSize: '0.8rem' }} 
                 className="text-sm">{errors.totalBeds1}
                 </span>
               )} */}
            </div>

            {/* Rent */}
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block mb-2 font-medium">Rent *</label>
                <input
                  type="number"
                  value={rent}
                  placeholder='Enter rent'
                  onChange={(e) => {
                    setRent(e.target.value);
                    setErrors({...errors, rent: "" });
                  }}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              {errors.rent && (
                <span 
                style={{ color: 'red', fontSize: '0.8rem' }} 
                className="text-sm">{errors.rent}
                </span>
              )}
              </div>
             
              {/* Security Deposit */}
              <div>
                <label className="block mb-2 font-medium">Security Deposit *</label>
                <input
                  type="number"
                  value={securityDeposit}
                  placeholder='Enter security deposit'
                  onChange={(e) => {
                    setSecurityDeposit(e.target.value);
                    setErrors({...errors, securityDeposit: "" });
                  }}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              {errors.securityDeposit && (
                <span 
                style={{ color: 'red', fontSize: '0.8rem' }} 
                className="text-sm">{errors.securityDeposit}
                </span>
              )}
              </div>
            </div>

            <div className="mb-4">
              <label className="block mb-2 font-medium">Facilities Offered</label>
              <div className="button-group">
                {facilityOptions.map((facility) => (
                  <button
                    key={facility}
                    className={`grid-item ${facilities.includes(facility) ? "active" : " "}`}
                    onClick={() => {
                      handleFacilityToggle(facility);
                      setErrors({ ...errors, facilities: "" });
                    }}
                    required
                  >
                    {facility}
                  </button>
                ))}
              </div>
                {errors.facilities && (
                <span 
                style={{ color: 'red', fontSize: '0.8rem' }} 
                className="text-sm">{errors.facilities}
                </span>
              )}
            </div>

            {/* Image Upload Section */}
            <div className="mb-4">
              <label className="block mb-2 font-medium">Upload Images</label>
              <input type="file" accept="image/*" multiple onChange={handleImageUpload} className="w-full p-2 border rounded-lg" />
              <div className="grid grid-cols-3 gap-2 mt-2">
                {images.map((image, index) => (
                  <img key={index} src={URL.createObjectURL(image)} alt="Uploaded" className="w-full h-20 object-cover rounded-lg" />
                ))}
              </div>
            </div>

            {/* Video Upload Section */}
            <div className="mb-4">
              <label className="block mb-2 font-medium">Upload Videos</label>
              <input type="file" accept="video/*" multiple onChange={handleVideoUpload} className="w-full p-2 border rounded-lg" />
              <div className="grid grid-cols-2 gap-2 mt-2">
                {videos.map((video, index) => (
                  <video key={index} controls className="w-full h-32 rounded-lg">
                    <source src={URL.createObjectURL(video)} type="video/mp4" />
                  </video>
                ))}
              </div>
            </div>

            {/* <button onClick={() => setStep(1)} className="next-button">
              back
            </button>
            <button onClick={() => setStep(3)} className="next-button">
              Next, add amenities
            </button> */}

          </div>
        )}




        {/* ---------------------------------------------------------- Add Amenities -------------------------------------------------------------- */}
        {currentStep === 3 && (
          <div>
            <h2 className="text-xl font-semibold mb-4">Add Amenities</h2>
            {/* Security Amenities */}
            <div className="mb-4">
              <h3 className="text-lg font-medium mb-2">Security Amenities</h3>
              <div className="button-group">
                {secuamenities.map((amenity) => (
                  <button
                    key={amenity}
                    className={`grid-item ${securityamenities.includes(amenity) ? "active" : ""}`}
                    onClick={() => {
                      setSecurityamenities(prev => prev.includes(amenity) ? prev.filter(item => item !== amenity) : [...prev, amenity]);
                    setErrors({ ...errors, securityamenities: "" });
                    }}
                    required
                  >
                    {amenity}
                  </button>
                ))}
              </div>
              {errors.securityamenities && (
                <span 
                style={{ color: 'red', fontSize: '0.8rem' }} 
                className="text-sm">{errors.securityamenities}
                </span>
              )}
            </div>

            {/* Furnishings in Property */}
            <div className="mb-4">
              <h3 className="text-lg font-medium mb-2">Furnishings in Property</h3>
              <div className="button-group">
                {FurnishingsinProperty.map((amenity) => (
                  <button
                    key={amenity}
                    className={`grid-item ${furnishingsinprop.includes(amenity) ? "active" : ""}`}
                    onClick={() =>{
                      setFurnishingsinprop(prev => prev.includes(amenity) ? prev.filter(item => item !== amenity) : [...prev, amenity]);
                    setErrors({ ...errors, furnishingsinprop: "" });
                    }}
                    required
                  >
                    {amenity}
                  </button>
                ))}
              </div>
              {errors.furnishingsinprop && (
                <span 
                style={{ color: 'red', fontSize: '0.8rem' }} 
                className="text-sm">{errors.furnishingsinprop}
                </span>
              )}
            </div>

            {/* Services */}
            <div className="mb-4">
              <h3 className="text-lg font-medium mb-2">Services</h3>
              <div className="button-group">
                {service1.map((amenity) => (
                  <button
                    key={amenity}
                    className={`grid-item ${service.includes(amenity) ? "active" : ""}`}
                    onClick={() => {
                      setService(prev => prev.includes(amenity) ? prev.filter(item => item !== amenity) : [...prev, amenity]);
                    setErrors({ ...errors, service: "" });
                    }}
                    required
                  >
                    {amenity}
                  </button>
                ))}
              </div>
              {errors.service && (
                <span 
                style={{ color: 'red', fontSize: '0.8rem' }} 
                className="text-sm">{errors.service}
                </span>
              )}
            </div>

            {/* Top Amenities */}
            <div className="mb-4">
              <h3 className="text-lg font-medium mb-2">Top Amenities</h3>
              <div className="button-group">
                {topamenities1.map((amenity) => (
                  <button
                    key={amenity}
                    className={`grid-item ${topamenities.includes(amenity) ? "active" : ""}`}
                    onClick={() => {
                      setTopamenities(prev => prev.includes(amenity) ? prev.filter(item => item !== amenity) : [...prev, amenity]);
                    setErrors({ ...errors, topamenities: "" });
                  }}
                  required
                  >
                    {amenity}
                  </button>
                ))}
              </div>
              {errors.topamenities && (
                <span 
                style={{ color: 'red', fontSize: '0.8rem' }} 
                className="text-sm">{errors.topamenities}
                </span>
              )}
            </div>
            {/* <button onClick={() => setStep(2)} className="next-button">
              back
            </button>
            <button onClick={() => setStep(4)} className="next-button">
              Next Address
            </button> */}
          </div>
        )}


        {currentStep === 4 && (
          <div >
            <h2 className="text-lg font-semibold">Add Address</h2>
            <p className="text-gray-600">Locality / Sector *</p>
            <input
        type="text"
        className="w-full border rounded-lg p-2 my-2"
        value={selectedLocality}
        onChange={(e) => setSelectedLocality(e.target.value)}
        placeholder="Enter location of the property.."
      />
      

      <h3 className="text-md font-medium mt-4">Where is your property located?</h3>
      <p className="text-sm text-gray-500">
        Search for a location or click on the map to select manually.
      </p>

      <div className="mapcontainer">
        <MapContainer center={position} zoom={14} style={{ height: "400px", width: "100%" }}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker position={position} icon={customIcon}>
            <Popup>{Address || "Click on the map to select location"}</Popup>
          </Marker>
          <LocationSelector setPosition={setPosition} setAddress={setAddress} setLocality={selectedLocality} />
        </MapContainer>
      </div>

      <p className="mt-2 text-gray-700">
        <strong>Selected Address:</strong> {Address}
      </p>
          {/* 
            <button className="next-button" onClick={handleSubmit}>
              Post Property
            </button>

            <button className='next-button' onClick={() => setStep(3)}>Back</button> */}
          </div>
        )}


<div className="button-group">
  {currentStep > 1 && (
    <button onClick={handlePrevStep} className="button prev">
      Back
    </button>
  )}
  {currentStep < steps.length ? (
    <button
      onClick={() => {
        if (validateForm()) {
          handleNextStep();
        } else {
          // Find the first error field and scroll to it
          const firstErrorKey = Object.keys(errors).find((key) => errors[key]);
          if (firstErrorKey) {
            const errorRef = getRefByKey(firstErrorKey); // Implement getRefByKey()
            if (errorRef && errorRef.current) {
              errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }
      }}
      className="button next"
    >
      Next
    </button>
  ) : (
    <button onClick={handleSubmit} className="button submit">
      Submit
    </button>
  )}
</div>
      </div>
      </div>

      </div>
    </div>
  );
};

export default AddProperty;
